import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import {AiFillHome} from "react-icons/ai";
import ContactForm from '../../components/ContactForm/ContactForm';
import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import useAnalytics from '../../hooks/useAnalytics';

const Appointment = () => {
    const { t } = useContext(LanguageContext);
    const { trackEvent } = useAnalytics();

    const mapLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.57587674014!2d29.0258808768176!3d40.99076707135299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9ce7b099fd3%3A0x5327e87ad0028c62!2zTU9OQSBLTMSwTsSwSyBBxJ5JWiBWRSBExLDFniBTQcSeTEnEnkkgUE9MxLBLTMSwTsSwxJ7EsA!5e0!3m2!1str!2str!4v1739185924730!5m2!1str!2str";

    React.useEffect(() => {
        trackEvent('appointment_form_view', { source: 'appointment_section' });
    }, [trackEvent]);

    return (
        <section className='appointment-section pb-70' data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <div className="google-map">
                            <iframe 
                                title='map' 
                                src={mapLink} 
                                style={{border: 0}}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>

                            <div className="location-name">
                                <AiFillHome />
                                <p>{t('appointment.contact.address')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <SectionTitle 
                                subTitle={t('appointment.sectionTitle')}
                                title={t('appointment.title')}
                                description={t('appointment.description')}/>

                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;